/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentForbiddenResponse model module.
 * @module model/AgentForbiddenResponse
 * @version 1.0.0
 */
class AgentForbiddenResponse {
    /**
     * Constructs a new <code>AgentForbiddenResponse</code>.
     * @alias module:model/AgentForbiddenResponse
     */
    constructor() { 
        
        AgentForbiddenResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentForbiddenResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentForbiddenResponse} obj Optional instance to populate.
     * @return {module:model/AgentForbiddenResponse} The populated <code>AgentForbiddenResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentForbiddenResponse();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentForbiddenResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentForbiddenResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }

        return true;
    }


}



/**
 * @member {String} message
 */
AgentForbiddenResponse.prototype['message'] = undefined;

/**
 * 拒否理由。後方互換のため省略可。未知・未指定の403はクライアントで通知対象にする。
 * @member {module:model/AgentForbiddenResponse.CodeEnum} code
 */
AgentForbiddenResponse.prototype['code'] = undefined;





/**
 * Allowed values for the <code>code</code> property.
 * @enum {String}
 * @readonly
 */
AgentForbiddenResponse['CodeEnum'] = {

    /**
     * value: "AGENT_ACCESS_BLOCKED"
     * @const
     */
    "AGENT_ACCESS_BLOCKED": "AGENT_ACCESS_BLOCKED",

    /**
     * value: "AGENT_IMPERSONATION_READ_ONLY"
     * @const
     */
    "AGENT_IMPERSONATION_READ_ONLY": "AGENT_IMPERSONATION_READ_ONLY",

    /**
     * value: "ASSESSMENT_PROPOSALS_DISABLED"
     * @const
     */
    "ASSESSMENT_PROPOSALS_DISABLED": "ASSESSMENT_PROPOSALS_DISABLED"
};



export default AgentForbiddenResponse;

